export default __webpack_public_path__ + "static/media/Fadejimi.5dc54dcb.mp4";